import TestimonialCard from "@/components/shared/TestimonialCard";
import { ErrorState, EmptyState } from "@/components/shared/DataState";
import { useAsyncData } from "@/hooks/useAsyncData";
import { getTestimonials } from "@/data/repository";
import { ASSETS } from "@/lib/brand";

export default function TestimonialsSection({ withHeading = true }) {
  const { data: testimonials, loading, error, reload } = useAsyncData(getTestimonials, []);
  return (
    <section
      data-testid="testimonials-section"
      className="section-pad relative overflow-hidden bg-olive"
    >
      <div className="absolute inset-0 opacity-20">
        <img src={ASSETS.lifestyle.bronzeTexture} alt="" className="h-full w-full object-cover" />
      </div>
      <div className="container-page relative">
        {withHeading && (
          <div className="text-center max-w-2xl mx-auto">
            <div className="eyebrow text-taupe mb-4 flex items-center justify-center gap-3">
              <span className="inline-block w-8 h-px bg-taupe" /> From My Clients
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.05]">
              Real Results, <span className="italic text-taupe">Real Stories.</span>
            </h2>
          </div>
        )}

        {loading && (
          <div className={`${withHeading ? "mt-14" : ""} grid grid-cols-1 lg:grid-cols-2 gap-7`} data-testid="loading-state">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="h-56 bg-cream/10 border border-cream/15 animate-pulse" />
            ))}
          </div>
        )}

        {!loading && error && <ErrorState onRetry={reload} message="" />}

        {!loading && !error && (
          <div className={`${withHeading ? "mt-14" : ""} grid grid-cols-1 lg:grid-cols-2 gap-7`}>
            {testimonials.map((t, i) => (
              <TestimonialCard key={t.id || i} t={t} idx={i} />
            ))}
          </div>
        )}

        {!loading && !error && testimonials.length === 0 && (
          <div className="text-center text-taupe py-16" data-testid="empty-state">
            <p className="font-serif text-2xl text-cream">Client stories coming soon.</p>
          </div>
        )}
      </div>
    </section>
  );
}
